angular.module('lsnBase.lazyLoad', []);